<!-- TOP Navigation -->
<nav class="navbar top-nav app-bg-primary">

  <div class="d-flex flex-row"
       style="align-items: center;flex-grow:2;gap:0 0.5rem;">
    <div class="navbar-brand d-flex pl-2 py-2">
      <img class="logo" alt="northstar logo" src="/static/images/icons/NstarFpoIcon@512px.png"
           (mousedown)="logoClicked()" [style.cursor]="currentUser?.devMode ? 'pointer': 'default'"/>
      <div class="logo-separator"></div>
      <img class="bt-logo" alt="bt logo" appDealerLogo (mousedown)="btLogoClicked($event)"/>
    </div>
    <button
      *ngIf="cnaService?.selectedOptions?.length>0"
      class="btn btn-sm rounded-pill app-btn-success cna-list-button"
      data-toggle="modal"
      data-target="#cna-modal"
      data-testid="nav-cna-list-btn"
      style="flex-grow:2;display: flex;justify-content: flex-end">
      <div class="cna-list-item" *ngFor="let item of cnaService?.selectedOptions;let i=index">
        <img [src]='getOptionIcon(item)' style="width:40px;height:40px"><span>{{ item }}</span>
      </div>
    </button>
    <div style="display:flex;gap:0.5rem;flex-grow:2;justify-content: flex-end">

      <!--button
        class="btn btn-sm rounded-pill app-btn-success cna-button"
        data-toggle="modal"
        data-target="#cna-modal">
        <span
          style="margin:0">{{ ((cnaService.firstName || cnaService.lastName) ? (cnaService.firstName || '') + ' ' + (cnaService.lastName ? cnaService.lastName.toUpperCase().substr(0, 1) + '.' : '') : 'New Customer') }}</span>
      </button-->

      <button
        class="btn btn-sm rounded-pill app-btn-success grey-button" style="text-wrap: nowrap"
        data-testid="nav-create-writeup-btn"
        (click)="modulePathLink('/clearpath/new-deal');clearFocus($event.target);">
        Create Writeup
      </button>

      <!--<button
        class="btn btn-sm rounded-pill app-btn-success grey-button" style="text-wrap: nowrap"
        (click)="toastTest()">
        Toast Test
      </button>-->

      <!--<button
        class="btn btn-sm rounded-pill app-btn-success grey-button"
        (mousedown)="openRouteOneTab();clearFocus($event.target);">
        Credit Check
      </button>-->

      <!--<button
        *ngIf="isSysAdmin() || isSalesManager()"
        class="btn btn-sm rounded-pill app-btn-success grey-button"
        (mousedown)="getInventory2()">
        Get Inventory
      </button>-->

      <!--button
        *ngIf="isSysAdmin() || isSalesManager()"
        class="btn btn-sm rounded-pill app-btn-success grey-button"
        (mousedown)="notificationsClicked()">
        <i class="material-icons app-text-white">notifications</i>
        {{ countNotifications$() | async }} Alerts
      </button-->

      <div class="dropdown">
        <button
          class="btn btn-sm rounded-pill app-btn-success user-button"
          style="text-wrap: nowrap"
          data-testid="nav-user-menu-btn"
          (click)="appService.userSidenavOpened=true;clearFocus($event.target);">
          {{ currentUser.firstName | titlecase }} {{ currentUser.lastName.toUpperCase().substr(0, 1) }}.
          <i class="material-icons app-text-white" style="margin:0 -4px 0 6px">menu</i>
        </button>
        <div class="dropdown-menu dropdown-menu-right">
          <div class="px-3 small">Logged in as:</div>
          <div class="dropdown-divider"></div>
          <div class="px-3 font-weight-bold small" style="font-size:18px">{{ userName | titlecase }}</div>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" data-testid="nav-logout-link" (mousedown)="logout()">Log Out</a>
          <!--div *ngIf="adminRoutes.length > 0">
            <div class="dropdown-divider"></div>
            <div class="px-3 font-weight-bold small">Admin</div>
            <div class="dropdown-divider"></div>
            <ng-container *ngFor="let route of adminRoutes">
              <ng-container *ngIf="route.title=='Settings'">
                <a [routerLink]="route.routerLink" class="dropdown-item">{{ route.title }}</a>
              </ng-container>
            </ng-container>
          </div-->
        </div>
      </div>
    </div>
  </div>
</nav>
<app-breadcrumb></app-breadcrumb>
<!-- SUB Navigation -->
<nav class="context-navbar context-navbar-layout"
     style="grid-template-columns: unset!important;grid-gap:0;padding:0!important;">
  <!--<section class="header-bar-container context-navbar-col-right-layout"
           style="flex: 1 1 auto;display:flex!important;width:100%;grid-gap:0!important;border-bottom:1px solid #375320!important;">
    <ng-container *ngFor="let route of standardRoutes; let i = index;">
      &lt;!&ndash;ng-container *ngIf="route.title=='Credit Check'">
        <button
          class="header-button btn btn-sm rounded-pill border-white flex-grow-1" style="outline-width: 0!important;outline:none!important;"
          [ngClass]="isActiveRoute(route.routerLink) ? 'app-btn-success' : 'app-btn-neutral'"
          (mousedown)="openRouteOneTab()">
          {{ route.title }}
        </button>
      </ng-container&ndash;&gt;
      <ng-container *ngIf="route.title!='Credit Check'">
        <button
          class="header-button btn btn-sm rounded-pill border-white "
          style="flex: 1 1 auto;;outline-width: 0!important;outline:none!important;"
          [ngClass]="isActiveRoute(route.routerLink) ? 'app-btn-success' : 'app-btn-neutral'"
          (mousedown)="onSelectRoute(route.routerLink)">
          {{ route.title }}
        </button>
      </ng-container>
      <div *ngIf="i!=standardRoutes.length-1 && i!=0"
           style="height: 100%;border-left:1px solid #32521a!important;min-width:1px;max-width:1px;"></div>
    </ng-container>
  </section>-->
  <!--<section class="context-navbar-col-left-layout" *ngIf="isContextual() || showTeamSelect()">
    &lt;!&ndash;app-manager-select *ngIf="showTeamSelect()" style="min-width: 200px;"></app-manager-select&ndash;&gt;
    <app-search-form *ngIf="isContextual()" [placeholder]="'Search'" style="width: 100%"></app-search-form>
  </section>-->


</nav>
<!-- CNA Modal -->
<div id="cna-modal" #cnaModal class="modal fade cna-modal">
  <div class="modal-dialog p-2 p-sm-4 m-0" style="max-width: 100vw">
    <div class="modal-content modal-body">
      <app-dialog-close-button
        data-dismiss="modal"
        layoutMode="float">
      </app-dialog-close-button>
      <h3 id="modal-basic-title">Customer Priorities</h3>
      <div class="section-info" style="margin-top:5px;"><b>Optional:</b> Enter the customer's name below.</div>
      <section class="model-info" style="margin-top:10px;width: 100%;display: flex">
        <span>Customer's Name:</span>
        <input placeholder="First Name" [ngModel]="cnaService.firstName"
               (ngModelChange)="updateCustomerFirstName($event)">
        <input placeholder="Last Name" [ngModel]="cnaService.lastName" (ngModelChange)="updateCustomerLastName($event)">
      </section>
      <div class="section-info"><b>Recommended:</b> Drag and drop the customer's top priorities.</div>
      <section class="wants">
        <div class="cna-list-container">
          <h2>Unselected Priorities</h2>
          <div
            id="sourceList"
            #todoList="cdkDropList"
            cdkDropList
            [cdkDropListData]="cnaService.allOptions"
            [cdkDropListConnectedTo]="[doneList]"
            class="cna-item-list"
            (cdkDropListDropped)="drop($event)">
            <div class="cna-list-item" *ngFor="let item of cnaService.allOptions" cdkDrag>
              <img [src]='getOptionIcon(item)'><span>{{ item }}</span>
              <div *cdkDragPreview class="cna-list-item"
                   style="background: #fff!important;color:#000!important;padding:10px!important;"><img
                [src]='getOptionIcon(item)' style="width:40px;height:40px"><span>{{ item }}</span></div>
            </div>
          </div>
        </div>
        <div class="cna-list-container">
          <h2>Selected Priorities</h2>
          <div
            id="targetList"
            #doneList="cdkDropList"
            cdkDropList
            [cdkDropListData]="cnaService.selectedOptions"
            [cdkDropListConnectedTo]="[todoList]"
            class="cna-item-list"
            (cdkDropListDropped)="drop($event)">
            <div class="cna-list-item" *ngFor="let item of cnaService.selectedOptions" cdkDrag>
              <img [src]='getOptionIcon(item)'><span>{{ item }}</span>
              <div *cdkDragPreview class="cna-list-item"
                   style="background: #fff!important;color:#000!important;padding:10px!important;"><img
                [src]='getOptionIcon(item)' style="width:40px;height:40px"><span>{{ item }}</span></div>
            </div>
          </div>
        </div>
      </section>
      <div
        style="text-align: right;margin-top:15px;display: flex;align-items: center;justify-content: flex-end;gap:15px">
        <button
          (mousedown)="resetForm()"
          mat-raised-button
          class="reset-form-button">Reset Form
        </button>
        <button mat-raised-button data-dismiss="modal" class="green-button">Done</button>
      </div>
    </div>
  </div>
</div>
